import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "customtranslate",
})
export class CustomTranslatePipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(value: string, param: string): string {
        if (
            this.translateService.instant(value) === value &&
            param !== undefined
        ) {
            return this.translateService.instant(param);
        }

        return this.translateService.instant(value);
    }
}
